import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import Reviews from './../block/Reviews'
import Social from './../block/Social'
import Takze from './../block/Takze'
import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'

class NashiOtzivi extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <Breadcrumbs items={data?.breadcrumbs || []} />
        <Reviews
          data={data?.reviews || {}}
          logo={data?.logo}
          sitename={data?.sitename}
          assets_path={assets_path}
          margin={`y`}
          text={`Реальные мнения о производстве  и установке деревянных евроокон`}
        />
        <Social
          data={data?.social || {}}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
          vklink={data?.vklink}
          youlink={data?.youlink}
          rutubelink={data?.rutubelink}
        />
        <Takze
          data={data?.ourvalues || {}}
          id={data?.id || 0}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
        />
      </>
    )
  }
}

NashiOtzivi.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

NashiOtzivi.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default NashiOtzivi